import { createUploadStartBIData, createUploadEndBIData } from '../biCallbacks/mediaUploadBI.js';
import 'wix-rich-content-common/libs/uuid';

class UploadService {
  constructor(streamReader, updateService) {
    this.topicsToPublish = [
      "ricos.upload.functionality.uploadStarted",
      "ricos.upload.functionality.uploadFinished"
    ];
    this.streamReader = streamReader;
    this.updateService = updateService;
    this.onInputChange = null;
  }
  setErrorNotifier(getErrorNotifer) {
    this.getErrorNotifier = getErrorNotifer;
  }
  setHiddenInputElement(getHiddenInputElement) {
    this.getHiddenInputElement = getHiddenInputElement;
  }
  selectFiles(accept = "image/*", multiple, callback) {
    const hiddenInputElement = this.getHiddenInputElement();
    this.onInputChange && hiddenInputElement.removeEventListener("change", this.onInputChange);
    this.onInputChange = (event) => {
      const files = Array.from(event.target.files || []);
      event.target.value = null;
      callback(files);
    };
    hiddenInputElement.addEventListener("change", this.onInputChange, { once: true });
    hiddenInputElement.accept = accept;
    hiddenInputElement.multiple = !!multiple;
    hiddenInputElement.click();
  }
  async uploadFile(file, nodeId, uploader, type, MediaPluginService, fileState) {
    const errorNotifier = this.getErrorNotifier();
    try {
      const url = await this.streamReader.read(file);
      const newFileState = this.updateService.updateLoadingState(
        url,
        file,
        nodeId,
        type,
        MediaPluginService,
        fileState
      );
      const uploadStartBiData = createUploadStartBIData(type, file.size, file.type);
      this.publishers.byTopic("ricos.upload.functionality.uploadStarted").publish(uploadStartBiData);
      let error;
      try {
        const uploadedFile = await uploader.upload(file);
        this.updateService.updatePluginData(
          uploadedFile,
          nodeId,
          type,
          MediaPluginService,
          newFileState
        );
        this.streamReader.free(url);
      } catch (e) {
        error = e;
        errorNotifier.notify(e);
        this.updateService.updateErrorState(e, nodeId, type, MediaPluginService, newFileState);
      } finally {
        const uploadFinishedBiData = createUploadEndBIData(uploadStartBiData, error);
        this.publishers.byTopic("ricos.upload.functionality.uploadFinished").publish(uploadFinishedBiData);
      }
    } catch (e) {
      errorNotifier.notify({ msg: "Failed reading file locally" });
    }
  }
}

export { UploadService };
//# sourceMappingURL=UploadService.js.map
